import React__default from "react";
import clsx from "clsx";
import { Icon } from "../../icon/icon/icon.mjs";
const Star = (props) => {
  const { name, index, currentValue, handleSelect, ratingLabels, hoveredStar, onHover, required, invalidMessage } = props;
  const value = index + 1;
  const renderStarIcon = (index2) => {
    if (invalidMessage && !currentValue && !hoveredStar) {
      return "#star-line";
    }
    if (hoveredStar) {
      return hoveredStar > index2 ? "#star" : "#star-line";
    }
    return currentValue > index2 ? "#star" : "#star-line";
  };
  const renderStarIconColor = (index2) => {
    if (invalidMessage && !currentValue && !hoveredStar) {
      return "rating__star--error";
    }
    if (hoveredStar) {
      return hoveredStar > index2 ? "rating__star--hover" : "rating__star--unselected";
    }
    return currentValue > index2 ? "rating__star--selected" : "rating__star--unselected";
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: index }, /* @__PURE__ */ React__default.createElement(
    "input",
    {
      type: "radio",
      id: "".concat(name, "-").concat(value),
      name,
      value,
      checked: currentValue === value,
      onChange: () => handleSelect(value),
      required,
      className: "rating__star-input"
    }
  ), /* @__PURE__ */ React__default.createElement("label", { htmlFor: "".concat(name, "-").concat(value), className: "rating__star-label", onMouseEnter: () => onHover(value), onMouseLeave: () => onHover(null) }, /* @__PURE__ */ React__default.createElement("span", { className: "rating__star-hidden-label" }, "".concat(value, " - ").concat(ratingLabels[value])), /* @__PURE__ */ React__default.createElement(Icon, { modifiers: renderStarIcon(index), className: clsx("rating__star", renderStarIconColor(index)) })));
};
export {
  Star
};
